import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import PublicLayout from "../templates/layouts/public/Layout";
import ForbiddenPage from "../views/errors/ForbiddenPage";
import { USER_TYPES } from "../utils/userTypeConstants";
import {
  isStaffPortalDeactivated,
  canStaffUpdateAvailability,
  refreshStaffPortalPermissions,
} from "../utils/authHelper";
import StaffAvailabilityLockedPage from "../views/staff/StaffAvailabilityLockedPage";
import Spinner from "../components/Spinner";

const STAFF_SCHEDULE_PATH = "/staff/schedule";

const PrivatePage = ({ appRoute }) => {
  const isStaffRoute = appRoute.userType === USER_TYPES.staff;
  const isStaffScheduleRoute =
    isStaffRoute && appRoute.path === STAFF_SCHEDULE_PATH;

  const [permissionsReady, setPermissionsReady] = useState(!isStaffRoute);
  const [availabilityAllowed, setAvailabilityAllowed] = useState(
    canStaffUpdateAvailability()
  );

  useEffect(() => {
    if (!isStaffRoute) {
      return;
    }

    refreshStaffPortalPermissions(() => {
      setAvailabilityAllowed(canStaffUpdateAvailability());
      setPermissionsReady(true);
    });
  }, [isStaffRoute]);

  if (isStaffRoute && !permissionsReady) {
    return <Spinner />;
  }

  if (isStaffRoute && isStaffPortalDeactivated()) {
    return <Navigate to="/admin/user-type" replace />;
  }

  if (isStaffScheduleRoute && !availabilityAllowed) {
    return <StaffAvailabilityLockedPage />;
  }

  if (localStorage.userType && appRoute.userType !== localStorage.userType) {
    return <PublicLayout Component={ForbiddenPage} route={appRoute.path} />;
  }

  const Component = appRoute.component;
  return <Component route={appRoute.path} />;
};

export default PrivatePage;
